import React from "react";
import { Button, Row } from "react-materialize";
import Link from "react-router-dom/es/Link";
import Select from "react-select";
import { app } from "../app/app";
import { LoaderSection } from "../components/elements/LoaderSection";
import { FinaerSelect } from "../components/elements/Select";
import logo from "../images/logo-finaer.svg";

const HOUSING_TYPE_OPTIONS = [
  { value: "DEPARTAMENTO", label: "Departamento" },
  { value: "CASA_PH", label: "Casa/PH" },
];

const ROOM_OPTIONS = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4+", label: "4+" },
];

const AMENITIES = [
  { value: "cochera", label: "Cochera" },
  { value: "balcon_patio", label: "Balcón/Patio" },
  { value: "parrilla", label: "Parrilla" },
  { value: "apto_mascotas", label: "Apto mascotas" },
];

export class PropertySearchForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      invalidToken: false,
      submitted: false,
      submitting: false,
      applicant: {},
      cities: [],
      formData: {
        localidades: { value: [], error: "" },
        tipo_de_vivienda: { value: "", error: "" },
        ambientes: { value: "", error: "" },
        comodidades: { value: [], error: "" },
        valor_estimado_alquiler: { value: "", error: "" },
        valor_estimado_expensas: { value: "", error: "" },
      },
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLocalitiesChange = this.handleLocalitiesChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleAmenityChange = this.handleAmenityChange.bind(this);
    this.handleMoneyChange = this.handleMoneyChange.bind(this);
  }

  componentDidMount() {
    Promise.all([
      app.apiClient().getPropertySearchRequirement(this.token()),
      app.apiClient().getProvincesAndCities(),
    ])
      .then(([requirement, regions]) => {
        if (requirement && requirement.nombre) {
          this.setState({
            applicant: requirement,
            cities: this.cityOptionsFrom(regions.cities()),
            loading: false,
          });
        } else {
          this.setState({ invalidToken: true, loading: false });
        }
      })
      .catch((error) => {
        if (
          error &&
          error.message &&
          (error.message.includes("404") || error.message.includes("400"))
        ) {
          this.setState({ invalidToken: true, loading: false });
        } else {
          this.setState({ error: true, loading: false });
        }
      });
  }

  token() {
    return this.props.match.params.token;
  }

  cityOptionsFrom(cities) {
    return cities.map((city) => ({
      value: city.id(),
      label: city.name(),
    }));
  }

  handleLocalitiesChange(selectedOptions) {
    const selectedLocalities = (selectedOptions || []).slice(0, 2);
    const formData = this.state.formData;

    formData.localidades = {
      value: selectedLocalities,
      error: selectedLocalities.length ? "" : "Campo requerido",
    };

    this.setState({ formData });
  }

  handleSelectChange(fieldName, event) {
    const formData = this.state.formData;
    formData[fieldName] = {
      value: event.target.value,
      error: event.target.value ? "" : "Campo requerido",
    };

    this.setState({ formData });
  }

  handleAmenityChange(event) {
    const amenity = event.target.value;
    const checked = event.target.checked;
    const formData = this.state.formData;
    let amenities = formData.comodidades.value;

    if (checked) {
      amenities = [...amenities, amenity];
    } else {
      amenities = amenities.filter((value) => value !== amenity);
    }

    formData.comodidades = { value: amenities, error: "" };
    this.setState({ formData });
  }

  handleMoneyChange(fieldName, maxLength, event) {
    const digits = event.target.value.replace(/\D/g, "").slice(0, maxLength);
    const formData = this.state.formData;

    formData[fieldName] = {
      value: digits,
      error: this.moneyFieldError(fieldName, digits),
    };

    this.setState({ formData });
  }

  moneyFieldError(fieldName, value) {
    if (fieldName === "valor_estimado_expensas" && !value) {
      return "";
    }

    if (!value) {
      return "Campo requerido";
    }

    if (fieldName === "valor_estimado_alquiler" && value.length < 6) {
      return "Debe tener al menos 6 dígitos";
    }

    return "";
  }

  isValid() {
    const formData = this.state.formData;

    return (
      formData.localidades.value.length >= 1 &&
      formData.localidades.value.length <= 2 &&
      !!formData.tipo_de_vivienda.value &&
      !!formData.ambientes.value &&
      formData.valor_estimado_alquiler.value.length >= 6 &&
      formData.valor_estimado_alquiler.value.length <= 10 &&
      formData.valor_estimado_expensas.value.length <= 8
    );
  }

  validateForm() {
    const formData = this.state.formData;

    formData.localidades.error = formData.localidades.value.length
      ? ""
      : "Campo requerido";
    formData.tipo_de_vivienda.error = formData.tipo_de_vivienda.value
      ? ""
      : "Campo requerido";
    formData.ambientes.error = formData.ambientes.value
      ? ""
      : "Campo requerido";
    formData.valor_estimado_alquiler.error = this.moneyFieldError(
      "valor_estimado_alquiler",
      formData.valor_estimado_alquiler.value,
    );
    formData.valor_estimado_expensas.error = this.moneyFieldError(
      "valor_estimado_expensas",
      formData.valor_estimado_expensas.value,
    );

    this.setState({ formData });
    return this.isValid();
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.validateForm()) {
      return;
    }

    this.setState({ submitting: true });

    app
      .apiClient()
      .updatePropertySearchRequirement(this.token(), this.requestData())
      .then((success) => {
        this.setState({
          submitted: success,
          error: !success,
          submitting: false,
        });
      });
  }

  requestData() {
    const formData = this.state.formData;

    const requestData = {
      comodidades: formData.comodidades.value,
      localidades: formData.localidades.value.map((locality) => locality.value),
      tipo_de_vivienda: formData.tipo_de_vivienda.value,
      ambientes: formData.ambientes.value,
      valor_estimado_alquiler: parseInt(
        formData.valor_estimado_alquiler.value,
        10,
      ),
    };

    if (formData.valor_estimado_expensas.value) {
      requestData.valor_estimado_expensas = parseInt(
        formData.valor_estimado_expensas.value,
        10,
      );
    }

    return requestData;
  }

  formatMoney(value) {
    if (!value) {
      return "";
    }

    return "$ " + value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  hasError(fieldName) {
    return this.state.formData[fieldName].error;
  }

  render() {
    return (
      <div className="layout-request begin">
        <header>
          <Link className="site-logo" to="/">
            <img src={logo} className="app-logo" alt="logo" />
          </Link>
        </header>
        <main>{this.displayedContent()}</main>
      </div>
    );
  }

  displayedContent() {
    if (this.state.submitted) {
      return this.renderSuccessMessage();
    }

    if (this.state.invalidToken) {
      return this.renderInvalidToken();
    }

    if (this.state.error) {
      return this.renderErrorMessage();
    }

    if (this.state.loading) {
      return this.renderLoadingBox();
    }

    return this.renderForm();
  }

  renderLoadingBox() {
    return (
      <div className="information-paids-box col m6 col s12">
        <LoaderSection />
      </div>
    );
  }

  required() {
    return <span style={{ color: "red" }}>*</span>;
  }

  renderForm() {
    return (
      <div>
        <h1 style={{ fontSize: "36px", fontWeight: "600" }}>
          ¿Qué tipo de inmueble buscás?
        </h1>
        <p style={{ fontSize: "18px", fontWeight: "500" }}>
          Contanos tus preferencias y te ayudamos a encontrar la opción ideal
          para vos.
        </p>
        <h2
          style={{ fontSize: "25px", fontWeight: "500", marginBottom: "32px" }}
        >
          Solicitante: {this.state.applicant.nombre} ({this.state.applicant.nro}
          )
        </h2>

        <form noValidate onSubmit={this.handleSubmit}>
          <div
            className="middle-bar"
            style={{ padding: "40px", margin: "14px" }}
          >
            <div className="middle-bar-content" style={{ width: "50em" }}>
              <Row>
                <div className="col m12 s12 react-select">
                  <p>Localidad (máximo 2) {this.required()}</p>
                  <Select
                    name="localidades"
                    placeholder="Seleccionar..."
                    isMulti
                    value={this.state.formData.localidades.value}
                    onChange={this.handleLocalitiesChange}
                    options={this.state.cities}
                    isOptionDisabled={() =>
                      this.state.formData.localidades.value.length >= 2
                    }
                  />
                  {this.hasError("localidades") && (
                    <span
                      style={{
                        color: "#F44336",
                        fontSize: "12px",
                        marginLeft: "5px",
                      }}
                    >
                      {this.hasError("localidades")}
                    </span>
                  )}
                </div>
              </Row>

              <Row>
                <div className="col m6 s12 react-select">
                  <p>¿Qué tipo de vivienda estás buscando? {this.required()}</p>
                  <FinaerSelect
                    selectedOption={this.state.formData.tipo_de_vivienda.value}
                    name="tipo_de_vivienda"
                    onChange={(event) =>
                      this.handleSelectChange("tipo_de_vivienda", event)
                    }
                    options={HOUSING_TYPE_OPTIONS}
                    required={true}
                  />
                  {this.hasError("tipo_de_vivienda") && (
                    <span
                      style={{
                        color: "#F44336",
                        fontSize: "12px",
                        marginLeft: "5px",
                      }}
                    >
                      {this.hasError("tipo_de_vivienda")}
                    </span>
                  )}
                </div>

                <div className="col m6 s12 react-select">
                  <p>¿Cuántos ambientes necesitás? {this.required()}</p>
                  <FinaerSelect
                    selectedOption={this.state.formData.ambientes.value}
                    name="ambientes"
                    onChange={(event) =>
                      this.handleSelectChange("ambientes", event)
                    }
                    options={ROOM_OPTIONS}
                    required={true}
                  />
                  {this.hasError("ambientes") && (
                    <span
                      style={{
                        color: "#F44336",
                        fontSize: "12px",
                        marginLeft: "5px",
                      }}
                    >
                      {this.hasError("ambientes")}
                    </span>
                  )}
                </div>
              </Row>

              <Row>
                <div className="col m12 s12">
                  <p>Amenities</p>
                  {AMENITIES.map((amenity) => (
                    <span key={amenity.value} style={{ marginRight: "24px" }}>
                      <input
                        id={`amenity_${amenity.value}`}
                        name="comodidades"
                        type="checkbox"
                        className="custom-checkbox"
                        value={amenity.value}
                        checked={this.state.formData.comodidades.value.includes(
                          amenity.value,
                        )}
                        onChange={this.handleAmenityChange}
                      />
                      <label htmlFor={`amenity_${amenity.value}`}>
                        {amenity.label}
                      </label>
                    </span>
                  ))}
                </div>
              </Row>

              <Row>
                <div className="col m6 s12 react-select">
                  <p>Valor estimado de alquiler {this.required()}</p>
                  <input
                    className="money-input"
                    name="valor_estimado_alquiler"
                    type="text"
                    placeholder="Ingresá el valor estimado"
                    value={this.formatMoney(
                      this.state.formData.valor_estimado_alquiler.value,
                    )}
                    onChange={(event) =>
                      this.handleMoneyChange(
                        "valor_estimado_alquiler",
                        10,
                        event,
                      )
                    }
                  />
                  {this.hasError("valor_estimado_alquiler") && (
                    <span
                      style={{
                        color: "#F44336",
                        fontSize: "12px",
                        marginLeft: "5px",
                      }}
                    >
                      {this.hasError("valor_estimado_alquiler")}
                    </span>
                  )}
                </div>
                <div className="col m6 s12 react-select">
                  <p>Valor estimado de expensas</p>
                  <input
                    className="money-input"
                    name="valor_estimado_expensas"
                    type="text"
                    placeholder="Ingresá el valor estimado"
                    value={this.formatMoney(
                      this.state.formData.valor_estimado_expensas.value,
                    )}
                    onChange={(event) =>
                      this.handleMoneyChange(
                        "valor_estimado_expensas",
                        8,
                        event,
                      )
                    }
                  />
                  {this.hasError("valor_estimado_expensas") && (
                    <span
                      style={{
                        color: "#F44336",
                        fontSize: "12px",
                        marginLeft: "5px",
                      }}
                    >
                      {this.hasError("valor_estimado_expensas")}
                    </span>
                  )}
                </div>
              </Row>
            </div>
          </div>

          <Row className="submit-row">
            <Button
              className="round-btn"
              type="submit"
              disabled={!this.isValid() || this.state.submitting}
            >
              Enviar
            </Button>
          </Row>
        </form>
      </div>
    );
  }

  renderSuccessMessage() {
    return (
      <p>
        La información fue enviada exitosamente. Un asesor comercial te
        contactará a la brevedad.
      </p>
    );
  }

  renderInvalidToken() {
    return (
      <p>El link al que intentas acceder no es válido o ya fue utilizado.</p>
    );
  }

  renderErrorMessage() {
    return (
      <p>
        Se produjo un error al cargar o enviar la información. Ingresá
        nuevamente más tarde.
      </p>
    );
  }
}
